$(function () {
    $(document).on('click', '.trigger-collapse', function () {
        $(this).next('.collapse').slideToggle(100);
        $(this).find('.icon-dropdown').toggleClass('rotate-180');
        $(this).parent().toggleClass('bg-white-i');
    });
});
